<template>
  <div>
    <div class="title">联系方式</div>
    <div class="content">
      <div class="fl">
        <img src="http://img.chaofang.cn/images/company.jpg" alt="公司" />
      </div>
      <div class="fr">
        <div class="fr-content">
          <h3>龍之超</h3>
          <p style="margin-top: 35px">地址：{{ information.address }}</p>
          <p>电话：{{ information.phone }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      information: {},
    };
  },
  methods: {
    reqInformation() {
      axios.get("./data.json").then((res) => {
        this.information = res.data.information;
      });
    },
  },
  mounted() {
    this.reqInformation();
  },
};
</script>

<style scoped lang="less">
.title {
  height: 55px;
  line-height: 55px;
  font-size: 28px;
  border-bottom: 1px solid #dbd4cd;
  color: #2d8cf0;
  padding: 0;
  text-align: left;
}
.content {
  display: flex;
  padding-top: 25px;
}
.fl {
  width: 320px;
  height: 400px;
  background-color: #b5d4f0;
  img {
    width: 100%;
    height: 400px;
  }
}
.fr {
  flex: 1;
  padding-left: 50px;
  display: flex;
  align-items: center;
  margin-top: 200px;
}
</style>